import { render } from "./LocDiemDen.vue?vue&type=template&id=e290ff60&scoped=true"
import script from "./LocDiemDen.vue?vue&type=script&lang=js"
export * from "./LocDiemDen.vue?vue&type=script&lang=js"

import "./LocDiemDen.vue?vue&type=style&index=0&id=e290ff60&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e290ff60"]])

export default __exports__